import { LazyLoader, Modal } from '@bp/ui-components';
import { CourseForm } from 'components/CourseForm/CourseForm';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CourseModalProps = {
  isOpen: boolean;
  courseUuid: string | null;
  schoolYearUuid: string;
  canCollaborate: boolean;
  forceUserAsEditor: boolean;
  onClose: () => void;
};

export const CourseModal = ({
  isOpen,
  courseUuid,
  schoolYearUuid,
  canCollaborate,
  forceUserAsEditor,
  onClose,
}: CourseModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      isOpen={isOpen}
      loading={loading}
      onRequestClose={onClose}
      title={courseUuid === '' ? t('courses.editCourse') : t('courses.addCourse')}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='50vh' />}>
        <CourseForm
          courseUuid={courseUuid}
          schoolYearUuid={schoolYearUuid}
          onLoad={setLoading}
          onClose={onClose}
          canCollaborate={canCollaborate}
          forceUserAsEditor={forceUserAsEditor}
        />
      </Suspense>
    </Modal>
  );
};
